import { render, staticRenderFns } from "./quillEdit.vue?vue&type=template&id=15d78b10&scoped=true&"
import script from "./quillEdit.vue?vue&type=script&lang=js&"
export * from "./quillEdit.vue?vue&type=script&lang=js&"
import style0 from "./quillEdit.vue?vue&type=style&index=0&id=15d78b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d78b10",
  null
  
)

export default component.exports